import { cruiseConfig } from '@/config/cruise';
import { useCruise as useCruiseApi, useCruiseWithRoute as useCruiseWithRouteApi } from '../api/get-cruise';

const defaultYear = new Date().getFullYear();
const year = Number(cruiseConfig.cruiseYear) || defaultYear;
const reverse = cruiseConfig.cruiseReverse === 'true';

export function useCruise() {
  return useCruiseApi(cruiseConfig.cruiseId, year, reverse);
}

export function useCruiseWithRoute() {
  return useCruiseWithRouteApi(cruiseConfig.cruiseId, year, reverse, cruiseConfig.routeName);
}
